// services/sale/ExportInvoiceSaleService.ts
import { exportInvoiceSaleApi } from '../../api';

const ExportInvoiceSaleService = {
    addProduct: async (product: any) => {
        const response = await exportInvoiceSaleApi.addCustom('/products', product);
        return response.data;
    },

    updateProduct: async (product: any) => {
        const response = await exportInvoiceSaleApi.modifyCustom('/products', product);
        return response.data;
    },

    deleteProduct: async (detailId: number) => {
        const response = await exportInvoiceSaleApi.removeCustom(`/products/${detailId}`);
        return response.data;
    },

    getProductById: async (detailId: number) => {
        const response = await exportInvoiceSaleApi.fetchCustom(`/products/${detailId}`);
        return response.data;
    },

    updateExtras: async (saleId: number, payload: any) => {
        const response = await exportInvoiceSaleApi.modifyCustom(`/${saleId}/extras`, payload);
        return response.data;
    },

    getExportItemType: async (saleId: number) => {
        const response = await exportInvoiceSaleApi.fetchCustom(`/${saleId}/item-type`);
        return response.data;
    },

    updateIncoterm: async (saleId: number, payload: { incotermId: number }) => {
        const response = await exportInvoiceSaleApi.modifyCustom(
            `/${saleId}/incoterm`,
            payload
        );
        return response.data;
    },

    updateExportRegime: async (saleId: number, payload: { exportRegimeId: number }) => {
        const response = await exportInvoiceSaleApi.modifyCustom(
            `/${saleId}/export-regime`,
            payload
        );
        return response.data;
    },

    updateFiscalPrecinct: async (saleId: number, payload: { fiscalPrecinctId: number }) => {
        const response = await exportInvoiceSaleApi.modifyCustom(
            `/${saleId}/fiscal-precinct`,
            payload
        );
        return response.data;
    },
};

export default ExportInvoiceSaleService;
